import React, { useState, useRef, useEffect } from 'react';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import kumarAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import TypingDots from '../Components/TypingDots';
import { callOpenAI } from '../utils/openaiService';

const CareerTransition = () => {
  const chatRef = useRef(null);
  const [chatMessages, setChatMessages] = useState([
    {
      sender: 'ai',
      avatar: kumarAvatar,
      name: 'Kumar',
      message: `Hey, thinking of switching things up? 🔄

Whether you're feeling stuck, curious, or just ready for a change — I'm here to guide you.

Let’s explore roles that align with your interests, transferable skills, and long-term goals. 🚀

First, what’s your **current role or background**?`,
      timestamp: new Date().toLocaleString(),
    },
  ]);
  const [isTyping, setIsTyping] = useState(false);
  const [placeholder, setPlaceholder] = useState("What's your current job or background?");

  const examplePlaceholders = [
    "I'm a teacher but want to move into UX design",
    "Currently in sales, interested in product management",
    "I feel stuck — what roles fit my strengths?",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholder((prev) => {
        const currentIndex = examplePlaceholders.indexOf(prev);
        return examplePlaceholders[(currentIndex + 1) % examplePlaceholders.length];
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [chatMessages, isTyping]);

  const handleSend = async (text) => {
    if (!text.trim()) return;
    setIsTyping(true);

    const newUserMessage = {
      sender: 'user',
      avatar: userAvatar,
      name: 'You',
      message: text,
      timestamp: new Date().toLocaleString(),
    };

    const updatedMessages = [...chatMessages, newUserMessage];
    setChatMessages(updatedMessages);

    const formattedMessages = updatedMessages.map((msg) => ({
      role: msg.sender === 'ai' ? 'assistant' : 'user',
      content: msg.message,
    }));

    const reply = await callOpenAI({
      messages: formattedMessages,
      screenContext: 'careertransition',
    });

    const aiResponse = {
      sender: 'ai',
      avatar: kumarAvatar,
      name: 'Kumar',
      message: reply,
      timestamp: new Date().toLocaleString(),
    };

    setChatMessages((prev) => [...prev, aiResponse]);
    setIsTyping(false);
  };

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-between min-h-[75vh] w-full max-w-[950px] mx-auto">
  <div className="flex flex-col gap-6 overflow-y-auto flex-grow pr-2 custom-scroll max-h-[65vh]" ref={chatRef}>
    {chatMessages.map((msg, idx) => (
      <ChatBubble
        key={idx}
        sender={msg.sender}
        avatar={msg.avatar}
        name={msg.name}
        message={msg.message}
        timestamp={msg.timestamp}
      />
    ))}
    {isTyping && (
      <ChatBubble
        sender="ai"
        avatar={kumarAvatar}
        name="Kumar"
        message={<TypingDots />}
      />
    )}
  </div>

  <div className="mt-6">
    <MessageInput onSend={handleSend} placeholder={placeholder} />
  </div>
</div>

  );
};

export default CareerTransition;
